// The composer's Lampirkan file button: a 44px paperclip in the composer's
// leading lane and the hidden multi-file input it opens.
import { useRef } from "react";
import { Glyph } from "../ui/icons";
import { ACCEPT } from "./attachments";

export function AttachmentPicker({ onFiles, disabled = false, multiple = true }: { onFiles: (files: File[]) => void; disabled?: boolean; multiple?: boolean }) {
  const input = useRef<HTMLInputElement>(null);
  return (
    <div className="composer-attach">
      <button type="button" className="ui-icon-btn composer-attach-btn" aria-label="Lampirkan file" title="Lampirkan file" disabled={disabled} onClick={() => input.current?.click()}>
        <Glyph name="add" size={24} />
      </button>
      <input
        ref={input}
        className="composer-file"
        type="file"
        multiple={multiple}
        accept={ACCEPT}
        tabIndex={-1}
        aria-hidden="true"
        hidden
        disabled={disabled}
        onChange={(e) => {
          const files = Array.from(e.currentTarget.files ?? []);
          // Reset so the same file can be picked again after removing it.
          e.currentTarget.value = "";
          onFiles(files);
        }}
      />
    </div>
  );
}
